import {Component, Input} from '@angular/core';
import {NgForOf} from "@angular/common";
import {TranslatePipe} from "@ngx-translate/core";

type ClientFeedback = {
  industry: string;
  feedback: string;
  reviewerName: string;
  reviewerCompany: string;
  rating: number;
}

@Component({
  selector: 'app-client-feedback-card',
  imports: [
    NgForOf,
    TranslatePipe
  ],
  templateUrl: './client-feedback-card.component.html',
  styleUrl: './client-feedback-card.component.scss'
})
export class ClientFeedbackCardComponent {
  @Input() clientFeedbacks: ClientFeedback[] = [];
  protected readonly Array = Array;
}
